import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NSamplesCheckoutSuccessCms } from './samples-checkout-success-cms.component';
@Injectable({ providedIn: 'root' })
export class SamplesCheckoutSuccessCmsResolver implements Resolve<void | ICmsBlock<NSamplesCheckoutSuccessCms.IBlockData>> {
    constructor(private iCmsBlockResource: ICmsBlockResource) { }
    resolve(): Promise<void | ICmsBlock<NSamplesCheckoutSuccessCms.IBlockData>> {
        return this.iCmsBlockResource.retrieve({ bareUrl: NSamplesCheckoutSuccessCms.BLOCK_ID }, undefined);
    }
}
